module.exports = __webpack_public_path__ + "static/media/20210501_091914726_iOS.9cc8f5b1.jpg";